import React, { useState } from "react";
import { Col, Container, Row, Accordion } from "react-bootstrap";
import {
  logoColor,
  AllStepsBg,
  AllStepsRocketImg,
  ArrowUpRightBlue,
  GraySmily,
  CheckCircleIconGreen,
  CancelCircleIconRed,
} from "../../../../constant/imagePath";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { BeforeLoginHeader } from "../../../../stories/BeforeLoginHeader/BeforeLoginHeader";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { Button } from "../../../../stories/Button/Button";
import CongratsModal from "../../../../components/Modals/CoachFlow/OnBoarding/Congrats/Congrats";
import classes from "./AllStepsMobile.module.css";
import { MobileHeader } from "../../../../stories/MobileHeader/MobileHeader";
import { useHistory } from "react-router-dom";

export default function AllStepsMobile() {
  const [isOpen, setIsOpen] = useState(false);
  const [isCongrats, setIsCongrats] = useState(false);

  const history = useHistory()
  const stepsData = [
    {
      stepTitle: "Step 1",
      heading: "Getting to know you",
      isDone: true,
      lists: [
        {
          label: "Personal Info", isDone: false,
          onClick: () => history.push({ pathname: '/on-boarding', state: { mainStep: 1, childStep: 1 } })
        },
        {
          label: "Background Check", isDone: true,
          onClick: () => history.push({ pathname: '/on-boarding', state: { mainStep: 1, childStep: 2 } })

        },
      ],
    },
    {
      stepTitle: "Step 2",
      heading: "Setting up your lesson",
      isDone: false,
      lists: [
        {
          label: "Set lesson", isDone: false,
          onClick: () => history.push({ pathname: '/on-boarding', state: { mainStep: 2, childStep: 1 } })
        },
        {
          label: "Address", isDone: true,
          onClick: () => history.push({ pathname: '/on-boarding', state: { mainStep: 2, childStep: 2 } })
        },
        {
          label: "FAQ", isDone: true,
          onClick: () => history.push({ pathname: '/on-boarding', state: { mainStep: 2, childStep: 3 } })
        },
        {
          label: "Price", isDone: false,
          onClick: () => history.push({ pathname: '/on-boarding', state: { mainStep: 2, childStep: 4 } })
        },
      ],
    },
    {
      stepTitle: "Step 3",
      heading: "Set your schedule",
      isDone: false,
      onClick: () => history.push({ pathname: '/on-boarding', state: { mainStep: 3, childStep: 1 } })
    },
  ];
  return (
    <>
      <style jsx>{`
        .accordion-item {
          border: 0px;
          border-bottom: 1px solid ${Colors.neutralShadesOfWhisper};
        }
        .accordion-button:not(.collapsed) {
          color: ${Colors.neutralShadesOfNero};
        }
        .accordion-button {
          padding: 16px 0px;
        }
        .accordion-body {
          padding: 0px 0px 16px 0px;
        }
      `}</style>

      <div className={classes.allSteps}>
        <Container fluid className="p-0">
          <Row className="g-0
          ">
            <Col sm={12}>
              <div
                className={classes.bg}
                style={{ background: `url(${AllStepsBg})` }}
              >
                <MobileHeader isLogo={true} isAvatar={false} />
                <h3 style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}>
                  ONE MORE STEP TO GO!
                </h3>
                <img src={AllStepsRocketImg} className={classes.rocketImg} />
              </div>
            </Col>
            <Col sm={12}>
              <div className={classes.overlayBox}>
                <div className={classes.stepsContainer}>
                  <Accordion
                    className={`${[classes.customAccordion].join(" ")}`}
                  >
                    {stepsData?.map((item, i) => {
                      return (
                        <Accordion.Item eventKey={i}>
                          <Accordion.Header
                          // onClick={() => toggleActive(i)}
                          >
                            <div
                              className={`${[classes.stepHeader].join(" ")}`}
                            >
                              <div>
                                <p
                                  style={{
                                    ...Fonts.otherMedium,
                                    color: Colors.neutralShadesOfDimGray,
                                  }}
                                >
                                  {item?.stepTitle}
                                </p>
                                <h5
                                  style={{
                                    ...Fonts.h5,
                                    color: Colors.neutralShadesOfNero,
                                  }}
                                >
                                  {item?.heading}
                                </h5>
                              </div>
                              <div>
                                <img
                                  src={item.isDone && CheckCircleIconGreen}
                                />
                              </div>
                            </div>
                          </Accordion.Header>

                          <Accordion.Body>
                            <ul className={classes.lists}>
                              {item?.lists?.map((listData) => {
                                return (
                                  <li
                                    className={`${[
                                      listData.isDone === true &&
                                      classes.listItemDone,
                                    ].join(" ")}`}
                                    style={{
                                      ...Fonts.b1Mobile,
                                      color: Colors.neutralShadesOfNero,
                                    }}
                                    onClick={listData?.onClick}
                                  >
                                    {listData?.label}
                                  </li>
                                );
                              })}
                            </ul>
                          </Accordion.Body>
                        </Accordion.Item>
                      );
                    })}
                  </Accordion>
                </div>

                {/* Buttons Box */}
                <div
                  className={classes.btnsBox}
                  style={{
                    borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                    backgroundColor: Colors.white
                  }}
                >
                  <Button
                    label={"Save"}
                    size={"Large"}
                    className={classes.btn}
                    customStyle={{ width: "162px", height: "56px" }}
                  />
                  <Button
                    label={"Finish"}
                    primary={true}
                    size={"Large"}
                    className={classes.btn}
                    customStyle={{ width: "162px", height: "56px" }}
                    onClick={() => setIsCongrats(true)}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <CongratsModal show={isCongrats} setShow={setIsCongrats} />
      </div>
    </>
  );
}
